import { QueryClient } from "@tanstack/react-query";

import { prefetchWorkflows } from "pages/WorkflowTablev2/WorkflowTablev2";
import { prefetchTemplates } from "pages/TemplateTablev2/TemplateTablev2";
import { prefetchContacts } from "pages/PeopleTablev2/PeopleTablev2";
import { prefetchGroups } from "pages/GroupTablev2/GroupTablev2";
import { prefetchInbox } from "pages/Inbox/Inbox";

// Warm the default view of every heavy list page into the query cache the
// moment a user is authenticated, so opening any of those pages renders from
// cache instead of waiting on a fresh request. Each prefetch is fire-and-
// forget and swallows its own errors — a failure just means that page loads
// the way it would have anyway.
export const prefetchAppData = (queryClient: QueryClient): void => {
  void prefetchWorkflows(queryClient);
  void prefetchTemplates(queryClient);
  void prefetchContacts(queryClient);
  void prefetchGroups(queryClient);
  void prefetchInbox(queryClient);
};
